import { FC } from 'react';
import { Autocomplete } from '@react-google-maps/api';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAutocomplete } from '@/editor/components/googleMaps/useAutocomplete';
import { useMapCircles } from '@/editor/components/googleMaps/useMapCircles';
import { useAppSelector } from '@/store/hooks/redux';
import { selectPlaces } from '@/editor/store/reducers/adSet-step.slice';

export enum CircleRadius {
  META = 17000,
  DEFAULT = 3000,
  MAX = 80000,
}

export const GoogleAutocomplete: FC = () => {
  const places = useAppSelector(selectPlaces);
  const { t } = useTranslation();

  const { locationRef, currentSearchValue, setCurrentSearchValue, selectedPlace } = useAutocomplete();
  useMapCircles(selectedPlace, CircleRadius.META);

  return (
    <Autocomplete
      options={{
        fields: ['geometry', 'formatted_address', 'name'],
      }}>
      <TextField
        size="small"
        error={places.length === 0}
        label={places.length > 0 ? t('pickLocation') : t('searchForLocation')}
        value={currentSearchValue}
        onChange={(e) => setCurrentSearchValue(e.target.value)}
        id={`autocomplete-1`}
        ref={locationRef}
        type="text"
        sx={{ width: '100%' }}
      />
    </Autocomplete>
  );
};
